const Config = {
    SENTRY_DSN: process.env.REACT_APP_SENTRY_DSN,
    SNOWPLOW_COLLECTOR_URL: process.env.REACT_APP_SNOWPLOW_COLLECTOR_URL,
    TIER: process.env.REACT_APP_TIER,
    SNOWPLOW_SCHEMA_API_KEY: process.env.REACT_APP_SNOWPLOW_SCHEMA_API_KEY
}

export { Config }